export class APP_USERS {
    constructor(
        public USER_ID: number,
        public USERNAME: string,
        public FULLNAME: string,
        public PASSWORD: string,
        public REPASSWORD: string,
        public CREATED_BY: number,
        public D_EXPIRY: Date,
        public SD_EXPIRY: string,
        public LOCK_YN: boolean,
        public GROUP_ID: number,
        public AP_ID: number,
        public SUB_AP_ID: number,
        public ROLE: number
    ) { }
}
export class VW_APP_USERS {
    constructor(
        public USER_ID: number,
        public USERNAME: string,
        public FULLNAME: string,
        public GROUPNAME: string,
        public D_EXPIRY: string,
        public LAST_LOGIN: string,
        public LOCK_YN: boolean
    ) { }
}
export class CHANGE_USER_PASS {
    constructor(
        public CURRENT_PASSWORD: string,
        public NEW_PASSWORD: string,
        public CONFIRM_PASSWORD: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/User.ts